/** Activa mocks locales del funnel neumáticos (vehículos, medidas y área privada). */
export function isDevNeumaticosMockEnabled(): boolean {
  return process.env.GATSBY_DEV_NEUMATICOS_MOCK === 'true'
}

export function normalizeMatriculaForDev(matricula: string): string {
  return matricula.replace(/\s/g, '').toUpperCase()
}
